/**
 * Feature flags
 *
 * AUTH_ENABLED — Controls whether sign-in / sign-up UI is exposed to users.
 * When false: all content is accessible to everyone, login prompts are hidden,
 * and the /auth route redirects home. All auth code (AuthProvider, Supabase
 * auth, AuthModal, etc.) remains wired up and can be re-enabled by flipping
 * this flag back to true.
 */
export const AUTH_ENABLED = false;
